(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-account-request"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wholesale-request-form')) {
    class WholesaleRequestForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form || this.form.dataset.wsrReady) return;
        this.form.dataset.wsrReady = 'true';

        this.mode = this.dataset.mode;
        this.endpoint = this.dataset.endpoint;
        this.maxBytes = Number(this.dataset.maxMb || 10) * 1024 * 1024;
        this.allowedTypes = (this.dataset.allowedTypes || '').split(',').map((t) => t.trim().toLowerCase());
        this.button = this.form.querySelector('[data-wsr-submit]');
        this.buttonLabel = this.button.textContent;
        this.status = this.form.querySelector('[data-wsr-status]');
        this.checkboxes = Array.from(this.form.querySelectorAll('[data-wsr-resell]'));
        this.resellError = this.form.querySelector('[data-wsr-resell-error]');
        this.fileInput = this.form.querySelector('[data-wsr-file]');
        this.fileError = this.form.querySelector('[data-wsr-file-error]');

        this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', () => this.validateResell(true)));
        // The custom validity lives on the first checkbox, so its native "invalid" event is
        // the cue to show the group's inline message.
        this.checkboxes[0]?.addEventListener('invalid', () => this.validateResell(true));
        this.fileInput?.addEventListener('change', () => this.validateFile());
        this.validateResell(false);
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
      }

      validateResell(showMessage) {
        if (!this.checkboxes.length) return true;
        const valid = this.checkboxes.some((checkbox) => checkbox.checked);
        const message = valid ? '' : this.dataset.resellError;
        this.checkboxes[0].setCustomValidity(message);
        this.checkboxes.forEach((checkbox) => checkbox.setAttribute('aria-invalid', String(!valid && showMessage)));
        if (this.resellError) {
          this.resellError.textContent = message;
          this.resellError.hidden = valid || !showMessage;
        }
        return valid;
      }

      validateFile() {
        if (!this.fileInput) return true;
        const file = this.fileInput.files[0];
        let message = '';
        if (file) {
          const extension = file.name.split('.').pop().toLowerCase();
          if (!this.allowedTypes.includes(extension)) message = this.dataset.fileTypeError;
          else if (file.size > this.maxBytes) message = this.dataset.fileSizeError;
        }
        this.fileInput.setCustomValidity(message);
        this.fileInput.setAttribute('aria-invalid', String(Boolean(message)));
        if (this.fileError) {
          this.fileError.textContent = message;
          this.fileError.hidden = !message;
        }
        return !message;
      }

      setBusy(busy) {
        this.button.disabled = busy;
        this.button.setAttribute('aria-busy', String(busy));
        this.button.textContent = busy ? this.dataset.submittingLabel : this.buttonLabel;
      }

      showMessage(type, text) {
        this.status.innerHTML = '';
        const message = document.createElement('div');
        message.className = `wsr__msg wsr__msg--${type}`;
        message.setAttribute('role', type === 'error' ? 'alert' : 'status');
        message.tabIndex = -1;
        message.textContent = text;
        this.status.appendChild(message);
        message.focus({ preventScroll: true });
        message.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      onSubmit(event) {
        const resellValid = this.validateResell(true);
        const fileValid = this.validateFile();
        if (!resellValid || !fileValid || !this.form.checkValidity()) {
          event.preventDefault();
          this.form.reportValidity();
          return;
        }

        // Shopify contact form: let the native POST go through; Shopify renders the result.
        if (this.mode === 'shopify') {
          this.setBusy(true);
          return;
        }

        event.preventDefault();
        this.submitExternal();
      }

      async submitExternal() {
        const honeypot = this.form.querySelector('[data-wsr-honeypot]');
        if (honeypot && honeypot.value) {
          this.form.reset();
          this.showMessage('success', this.dataset.successMessage);
          return;
        }

        const data = new FormData(this.form);
        const company = (this.form.querySelector('[data-wsr-company]')?.value || '').trim();
        const email = (this.form.querySelector('[data-wsr-email]')?.value || '').trim();
        data.set('_subject', company ? `${this.dataset.subjectPrefix} – ${company}` : this.dataset.subjectPrefix);
        data.set('_replyto', email);

        // Send the resale channels as one readable line instead of repeated keys.
        const resellName = this.checkboxes[0]?.name;
        if (resellName) {
          const channels = data.getAll(resellName);
          data.delete(resellName);
          data.append(resellName, channels.join(', '));
        }

        this.setBusy(true);
        this.status.innerHTML = '';
        try {
          const response = await fetch(this.endpoint, {
            method: 'POST',
            body: data,
            headers: { Accept: 'application/json' },
          });
          let json = null;
          try {
            json = await response.json();
          } catch (error) {
            json = null;
          }

          const failed = !response.ok || (json && (json.ok === false || json.success === false));
          if (!failed) {
            this.form.reset();
            this.validateResell(false);
            this.validateFile();
            this.showMessage('success', this.dataset.successMessage);
            return;
          }

          let errorText = this.dataset.errorMessage;
          if (json && Array.isArray(json.errors) && json.errors.length) {
            errorText = json.errors.map((item) => item.message || item).join(' ');
          } else if (json && (json.error || json.message)) {
            errorText = json.error || json.message;
          }
          this.showMessage('error', errorText);
        } catch (error) {
          this.showMessage('error', this.dataset.errorMessage);
        } finally {
          this.setBusy(false);
        }
      }
    }

    customElements.define('wholesale-request-form', WholesaleRequestForm);
  }

  } catch(e) { console.error(e); }
})();
})();
